import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base-service';
import { VisualParams } from '../models';

@Injectable()
export class VisualsService extends BaseService {
    private readonly visualsPath = '/data/visuals';
    private readonly acceptHeader = 'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8';

    private getVisualsUrl(visualId: string): string {
        return `${this.rootUrl}${this.visualsPath}/${visualId}`;
    }

    getVisual(visualId: string, params?: VisualParams): Observable<Blob> {
        const url = this.getVisualsUrl(visualId);
        const queryParams = this.buildParams(params);
        return this.http.get(url, {
            responseType: 'blob',
            params: queryParams,
            headers: {
                Accept: this.acceptHeader
            }
        });
    }
}
